import _ from "lodash";

const ChatReducerInitial = {
  unreadEventsByUsername: new Set<string>(),
  unreadEventsByRoomUid: {} as Record<string, Set<string>>,
};

export const ChatReducer = (
  state = ChatReducerInitial,
  action: { type: string; eventId?: string; roomUid: string },
) => {
  switch (action.type) {
    case "SET_UNREAD_EVENTS_BY_USERNAME": {
      const { eventId, roomUid } = action;
      if (!eventId) return state;
      const newState = _.cloneDeep(state);
      newState.unreadEventsByUsername.add(eventId);

      if (!newState.unreadEventsByRoomUid[roomUid]) {
        newState.unreadEventsByRoomUid[roomUid] = new Set<string>();
      }
      newState.unreadEventsByRoomUid[roomUid].add(eventId);
      return newState;
    }
    case "DELETE_UNREAD_EVENT_BY_USERNAME": {
      const { eventId, roomUid } = action;
      if (!eventId || !roomUid) return state;
      const newState = _.cloneDeep(state);
      newState.unreadEventsByUsername.delete(eventId);

      if (newState.unreadEventsByRoomUid[roomUid]) {
        if (newState.unreadEventsByRoomUid[roomUid].has(eventId)) {
          newState.unreadEventsByRoomUid[roomUid].delete(eventId);
        }
      }

      return newState;
    }
    default:
      return state;
  }
};
